import { Component, EventEmitter, Output, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { ThemeService } from 'src/@core/services/theme.service';

@Component({
  selector: 'hour4u-admin-drag-drop-upload',
  templateUrl: './drag-drop-upload.component.html',
  styleUrls: ['./drag-drop-upload.component.scss']
})
export class DragDropUploadComponent implements OnInit {
  @Input() skipUpload: boolean = false; // When true, skip upload and just emit files
  @Output() fileUploaded: EventEmitter<{ key: string, file: File }> = new EventEmitter<{ key: string, file: File }>();
  @Output() fileDeleted: EventEmitter<void> = new EventEmitter<void>(); // Emit event when file is deleted

  public selectedFileNames: string[] = [];
  private selectedFiles: File[] = [];
  @ViewChild('dropArea', { static: false }) dropArea!: ElementRef;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(private employerUploadService: EmployerUploadService,
    public themeService: ThemeService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    setTimeout(() => this.setupDragAndDrop(), 0);
  }

  setupDragAndDrop() {
    if (!this.dropArea) {
      console.error('Drop area not initialized.');
      return;
    }

    const dropArea = this.dropArea.nativeElement;

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.preventDefaults, false);
    });

    ['dragenter', 'dragover'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.highlight.bind(this), false);
    });

    ['dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, this.unhighlight.bind(this), false);
    });

    dropArea.addEventListener('drop', this.handleDrop.bind(this), false);
  }

  preventDefaults(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  highlight() {
    const dropArea = this.dropArea.nativeElement;
    dropArea.classList.add('highlight');
  }

  unhighlight() {
    const dropArea = this.dropArea.nativeElement;
    dropArea.classList.remove('highlight');
  }

  handleDrop(e: DragEvent) {
    this.preventDefaults(e);
    const dt = e.dataTransfer;
    const files = dt.files;

    if (files) {
      this.handleFiles(Array.from(files)); // Convert FileList to array
    }
  }

  handleFiles(files: File[]) {
    this.selectedFiles = files;
    this.selectedFileNames = files.map(file => file.name); // Map file names to array

    if (this.skipUpload) {
      // Skip upload, just emit files without uploading
      files.forEach(file => {
        this.fileUploaded.emit({ key: '', file: file }); // Emit file without key
      });
    } else {
      // Upload files as before (for backward compatibility)
      this.uploadFiles(files);
    }
  }

  uploadFiles(files: File[]) {
    files.forEach(file => {
      this.employerUploadService.uploadProfileImage(file).subscribe(
        (s3File) => {
          console.log('File uploaded successfully:', s3File.key);
          this.fileUploaded.emit({ key: s3File.key, file: file }); // Emit both the S3 file key and the file 
        },
        (error) => {
          console.error('Error uploading file to S3:', error);
        }
      );
    });
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(Array.from(input.files));
    }
  }
  deleteFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.selectedFileNames.splice(index, 1);

    // Clear the file input value to allow re-selecting the same file
    this.fileInput.nativeElement.value = '';

    this.fileDeleted.emit();
  }

  reset(): void {
    this.selectedFiles = [];
    this.selectedFileNames = [];
    this.fileInput.nativeElement.value = '';
  }
}
